import { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { useInitialData } from '../../components/data/DataContext';
import { useTranslation } from 'react-i18next';
import CRMPreview from './CRMPreview';
import { Button } from '../../components/ui/button';
import { Mail, Search } from 'lucide-react';
import googleLogo from '../../pages/authentication/google-logo.svg';
import { languagePrefixes } from '../../i18n';

const MainBlockFindInvestors = () => {
  const { t, i18n } = useTranslation();
  const { generalInfo } = useInitialData();

  // currentLanguage and prefix for building paths
  const currentLanguage = (i18n.language || 'en').split('-')[0];
  const prefix = languagePrefixes[currentLanguage] || '';

  const [totalInvestors, setTotalInvestors] = useState(
    generalInfo?.totalInvestors ?? null
  );
  const [loading, setLoading] = useState(generalInfo == null);
  const [error, setError] = useState(null);

  const formatTotalCount = (count) =>
    count ? Number(count).toLocaleString() : '';

  useEffect(() => {
    if (generalInfo) {
      setLoading(false);
      return;
    }

    const fetchTotalInvestors = async () => {
      try {
        const response = await fetch(`${API_URL}/general-info`);
        if (!response.ok) throw new Error('Network error while fetching data');
        const data = await response.json();
        setTotalInvestors(data.totalInvestors);
        setLoading(false);
      } catch (err) {
        if (err.message !== 'Failed to fetch') setError(err.message);
        setLoading(false);
      }
    };

    fetchTotalInvestors();
  }, [generalInfo]);

  return (
    /* === full-width background === */
    <section className="relative py-0 sm:py-24 left-1/2 transform -translate-x-1/2 w-screen flex flex-col lg:flex-row bg-gradient-to-r from-slate-50 to-gray-100">
      {/* === 75% width container, as in other sections === */}
      <div className="w-[80%] max-w-screen-xl mx-auto flex flex-col lg:flex-row-reverse gap-32 items-center">
        {/* Right column on desktop: text */}
        <div className="w-full lg:w-1/2 text-center py-20 lg:py-0">
          <h2 className="text-5xl mb-8">{t('pageHome.content.t1')}</h2>
          <p className="text-xl">{t('pageHome.content.t2')}</p>
          <p className="text-xl">{t('pageHome.content.t2.2')}</p>
          <p className="mt-4 text-sm ">{t('pageHome.content.t2.3')}</p>
          {error && <p className="text-red-500 mt-4">Error: {error}</p>}

          <div className="flex flex-col lg:flex-row items-center justify-center gap-6 mt-10">
            <Button
              href={`${prefix}/signup?utm_source=crino-homepage&utm_medium=find-the-right-investor-signup-button`}
              variant="default"
              size="sm"
              iconLeft={
                <>
                  <Mail className="h-4 w-4 mr-2" />
                  <img src={googleLogo} alt="Google logo" className="h-4 w-4" />
                </>
              }
            >
              {t('pageHome.content.t4')}
            </Button>
            <div className="mx-auto flex items-center justify-center"><a href="https://www.producthunt.com/products/investor-database?utm_source=badge-follow&utm_medium=badge&utm_source=badge-investor&#0045;database" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/follow.svg?product_id=309743&theme=light" alt="crino&#0046;io - crino&#0046;io&#0032;&#0045;&#0032;Research&#0044;&#0032;connect&#0032;&#0038;&#0032;track&#0032;investors&#0032;effortlessly | Product Hunt" style={{ width: "250px", height: "33px" }} width="250" height="54" /></a></div>
          </div>
        </div>

        {/* Left column on desktop: CRM preview */}
        <div className="hidden lg:flex w-full lg:w-1/2 justify-center">
          <CRMPreview />
        </div>
      </div>
    </section>
  );
};

export default MainBlockFindInvestors;
